import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";
import { WeChatEvent, WeChatManagerPeople } from "../../manager/WeChatConst";
import WeChatManager from "../../manager/WeChatManager";
import WeChatMainItem from "./WeChatMainItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WeChatMain extends cc.Component {

    @property({type:cc.Prefab,displayName:"itemPrefab"})
    itemPrefab:cc.Prefab = null;
    
    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    weChatManager:WeChatManager = null;

    bindManager(manager:WeChatManager){
        this.weChatManager = manager;
    }

    bindData(){
        this.bindManager(NormalGameManager._instance.weChatManager);
    }

    onLoad(): void {
        O1HD.getModules().uiControlModule.hideLoading();
    }

    async start():Promise<void>{
        await this.loadMain();
        O1HD.on(WeChatEvent.UPDATEWECHATMAIN,this.updateMain,this);

        utilsView.enterLayerDispose(UIKind.UILayerTag.WE_CHAT, this.node);
    }

    /**
     * 加载main
     */
    async loadMain(){
        return new Promise<void>(async resolve=>{
            let peopleAry:WeChatManagerPeople[] = this.weChatManager.getGameData().peoples;
            for(let i = 0; i<peopleAry.length; i++){
                await new Promise<void>(resolve=>{
                    let item = cc.instantiate(this.itemPrefab);
                    let is = item.getComponent(WeChatMainItem);
                    is.setData(peopleAry[i],this.weChatManager);
                    this.itemContent.addChild(item);
                    this.scheduleOnce(resolve);
                });
            }
            resolve();
        });
    }

    /**
     * 更新Main
     */
    updateMain(){
        let peopleAry:WeChatManagerPeople[] = this.weChatManager.getGameData().peoples;
        let maxCount = peopleAry.length;
        let contentCount = this.itemContent.childrenCount;
        // this.scheduleOnce(()=>{
            let needCount = maxCount - contentCount;
            if(maxCount == 0){
                for(let i =0;i<this.itemContent.childrenCount;i++){
                    let item = this.itemContent.children[i];
                    item.active = false;
                }
            }else if(needCount > 0){
                for(let i =0;i<this.itemContent.childrenCount;i++){
                    let item = this.itemContent.children[i];
                    let is = item.getComponent(WeChatMainItem);
                    if(i<peopleAry.length){
                        item.active = true;
                        is.setData(peopleAry[i],this.weChatManager);
                    }else{
                        item.active = false;
                    }
                }
                for(let i =0;i<needCount;i++){
                    let item = cc.instantiate(this.itemPrefab);
                    let is = item.getComponent(WeChatMainItem);
                    is.setData(peopleAry[contentCount + i],this.weChatManager);
                    this.itemContent.addChild(item);
                }
            }else{
                for(let i =0;i<this.itemContent.childrenCount;i++){
                    let item = this.itemContent.children[i];
                    let is = item.getComponent(WeChatMainItem);
                    if(i<peopleAry.length){
                        item.active = true;
                        is.setData(peopleAry[i],this.weChatManager);
                    }else{
                        item.active = false;
                    }
                }
            }
        // });
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    onDisable(): void {
        O1HD.emit("normalMode.onBackNormal", UIKind.UILayerTag.WE_CHAT);
    }

}